import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.gaskets || initialState;

const nonStandard = (state: RootState) => {
  if (state.gaskets?.data && state.gaskets?.data.length) {
    return state.gaskets.data.filter(gasket => gasket.isStandard);
  }
};
export const selectGaskets = createSelector([selectSlice], state => state);

export const selectStandardGasketsLoading = createSelector(
  [selectSlice],
  state => state.isLoading,
);
export const selectStandardGasketsError = createSelector(
  [selectSlice],
  state => state.error,
);

export const selectPriceLoading = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(
        standardGasket => standardGasket.erpPartNumber === erpPartNumber,
      )?.price.isLoading;
    }
  });
export const selectPriceError = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(
        standardGasket => standardGasket.erpPartNumber === erpPartNumber,
      )?.price.error;
    }
  });
export const selectPriceData = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(
        standardGasket => standardGasket.erpPartNumber === erpPartNumber,
      )?.price.data;
    }
  });
export const selectPriceQuantity = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(gasket => gasket.erpPartNumber === erpPartNumber)?.price
        .itemQuantity;
    }
  });

export const selectStockData = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(
        standardGasket => standardGasket.erpPartNumber === erpPartNumber,
      )?.stockStatus.data;
    }
  });

export const selectStockIsLoading = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(
        standardGasket => standardGasket.erpPartNumber === erpPartNumber,
      )?.stockStatus.isLoading;
    }
  });

export const selectStockError = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(
        standardGasket => standardGasket.erpPartNumber === erpPartNumber,
      )?.stockStatus.error;
    }
  });

export const selectGasketByErp = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(gasket => gasket.erpPartNumber === erpPartNumber);
    }
  });

export const selectNonStandardGasket = createSelector(
  [selectSlice],
  ({ data }) => {
    if (data && data.length) {
      return data.find(gasket => !gasket.isStandard);
    }
  },
);

export const selectStandardGaskets = createSelector(
  [selectSlice],
  ({ data }) => {
    if (data && data.length) {
      return data.filter(gasket => gasket.isStandard);
    }
  },
);

export const shouldFetchPrice = createSelector(
  [selectSlice],
  state => state.showPriceResults,
);

export const selectItemQuantity = (erpPartNumber: string) =>
  createSelector([selectSlice], ({ data }) => {
    if (data && data.length) {
      return data.find(gasket => gasket.erpPartNumber === erpPartNumber)?.price
        ?.itemQuantity;
    }
  });

export const selectIsReadyToSendListItemEvent = createSelector(
  [nonStandard],
  standardGaskets => {
    if (standardGaskets && standardGaskets.length) {
      const pricesCount = standardGaskets.reduce((acc, cur) => {
        if (!cur.price.isLoading && (cur.price.data || cur.price.error)) {
          return acc + 1;
        }
        return acc;
      }, 0);
      const stockCount = standardGaskets.reduce((acc, cur) => {
        if (
          !cur.stockStatus.isLoading &&
          (cur.stockStatus.data || cur.stockStatus.error)
        ) {
          return acc + 1;
        }
        return acc;
      }, 0);
      const isReady =
        pricesCount === standardGaskets.length &&
        stockCount === standardGaskets.length;
      return isReady;
    }
  },
);
